import DoubleArrowIcon from '@mui/icons-material/DoubleArrowRounded';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import { Avatar, Box, Typography } from '@mui/material';
import TimeAgo from 'javascript-time-ago';
import { useTranslation } from 'react-i18next';
import { CommandRequestStatus, NotificationFieldsFragment } from '../../../../../../../../generated/core-api/graphql-react-query';
import CommandStatusTag from '../CommandStatusTag';

export default function CommandRequestStatusChangedNotificationBox(props: { notification: NotificationFieldsFragment }) {
  const { notification } = props;
  const { t, i18n } = useTranslation('widgets');
  const timeAgo = new TimeAgo(i18n.language);
  return (
    <>
      <Avatar className="admin">
        <QuestionAnswerIcon />
      </Avatar>
      <Box className="message">
        <Typography variant="subtitle1">
          {t('notifications.command.updated.command')}
          <strong>{notification.event.command?.text}</strong>
          {t('notifications.command.updated.text')}
        </Typography>
        <Typography variant="body2" component="div">
          <CommandStatusTag status={notification.event.oldValue as CommandRequestStatus} />
          <DoubleArrowIcon />
          <CommandStatusTag status={notification.event.newValue as CommandRequestStatus} />
        </Typography>
        <Typography variant="subtitle2">
          {timeAgo.format(new Date(notification.date))}
        </Typography>
        <Typography variant="subtitle2">
          {notification.event.command?.commandRequest?.deletedAt && `${t('notifications.deleted')} ${timeAgo.format(new Date(notification.event.command?.commandRequest?.deletedAt))}`}
        </Typography>
      </Box>
    </>
  );
}
